import type { Position } from "geojson";
import { eraseSection } from "../../../domain/geometry/operations/erase";
import type { GeometryResult } from "../../../domain/geometry/types";
import type { UndoableCommand } from "../undoStack";

export interface ErasePolygonInput {
	rings: Position[][];
	p1: Position;
	pMid: Position;
	p2: Position;
}

export interface ErasePolygonResult {
	command: UndoableCommand;
	newRings: Position[][];
}

export function erasePolygonUseCase(
	input: ErasePolygonInput,
	applyResult: (newRings: Position[][]) => void,
	revert: (oldRings: Position[][]) => void,
): GeometryResult<ErasePolygonResult> {
	const newRings = eraseSection(input.rings, input.p1, input.pMid, input.p2);
	if (!newRings) return { ok: false, error: "Erase operation failed — invalid geometry or too few vertices." };
	const oldRings = input.rings;

	return {
		ok: true,
		data: {
			newRings,
			command: {
				label: "Erase polygon section",
				execute: () => applyResult(newRings),
				undo: () => revert(oldRings),
			},
		},
	};
}
